// app/javascript/components/GroupChannelPage.jsx

import React from "react";
import MessageContent from "@sendbird/uikit-react/ui/MessageContent";
import {MessageMenu} from "@sendbird/uikit-react/ui/MessageMenu";
import CustomMessageBody from "./CustomMessageBody";
import {TranslateMenuItem} from "./TranslateMenuItem";


export default function CustomMessageContent(props) {
    const {conversationId, ...messageContentProps} = props;

    return (
        <MessageContent
            {...messageContentProps}
            renderMessageMenu={(contentProps) => {
                const {isByMe} = contentProps;

                return (
                    <MessageMenu
                        {...contentProps}
                        renderMenuItems={(menuProps) =>
                            isByMe
                                ? renderMyMenuItems(menuProps, {...contentProps, conversationId})
                                : renderOtherMenuItems(menuProps, {...contentProps, conversationId})
                        }
                    />
                );
            }}
            renderMessageBody={(bodyProps) => (
                <CustomMessageBody
                    {...bodyProps}
                    conversationId={conversationId}
                />
            )}
        />
    );
}

const renderOtherMenuItems = (menuProps, contentProps) => {
    const {message, channel} = contentProps;
    return <TranslateMenuItem message={message} channel={channel}/>;
};

const renderMyMenuItems = (menuProps, contentProps) => {
    const {CopyMenuItem, EditMenuItem, DeleteMenuItem} = menuProps.items;
    const {message} = contentProps;

    return (
        <>
            {message.messageType === 'user' && <CopyMenuItem/>}
            {message.messageType !== 'file' && <EditMenuItem/>}
            <DeleteMenuItem/>
        </>
    );
};
